import { useAppConfig } from "@/api/app-config/useAppConfig";

interface ITtsConfig {
  isTtsEnabled: boolean;
  isExternalServiceForTts: boolean;
  ttsVoices: string[];
  isLoading: boolean;
}

export const useTtsConfig = (): ITtsConfig => {
  const { data, isLoading } = useAppConfig();
  return {
    isTtsEnabled: data?.audio.isTtsEnabled ?? false,
    isExternalServiceForTts: data?.audio.isExternalServiceForTts ?? false,
    ttsVoices: data?.audio.ttsVoices ?? [],
    isLoading,
  };
};
